import { server } from "@/api";

export const paginate = async (params) => {
    return await server().get('api/products', { params });
}

export const all = async (params) => {
    return await server().get('api/products', { params: { all: true, ...params } });
}

export const show = async (id) => {
    return await server().get(`api/products/${id}`);
}

export const create = async (product) => {
    return await server().post('api/products', product);
}

export const update = async (id, product) => {
    return await server().post(`api/products/${id}`, product);
}

export const remove = async (id) => {
    return await server().delete(`api/products/${id}`);
}

export default { paginate, all, show, create, update, remove };
